"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var vue_1 = require("vue");
var reactivity_1 = require("@vue/reactivity");
var jquery_1 = __importDefault(require("jquery"));
exports["default"] = (0, vue_1.defineComponent)({
    props: {
        fakeer: Object,
        removeAddressButton: Boolean,
    },
    setup: function (__props, _a) {
        var expose = _a.expose;
        expose();
        var props = __props;
        window.$ = window.jQuery = jquery_1["default"];
        var uniqueId = Date.now();
        var countries = (0, reactivity_1.computed)(function () {
            return window.countries;
        });
        var institutions = (0, reactivity_1.computed)(function () {
            return window.institutions;
        });
        function removeElement() {
            /**
             * @type {HTMLDivElement}
             */
            var element = document.getElementById('form' + uniqueId);
            element.parentNode.removeChild(element);
        }
        function countryInputChange(event) {
            var countries = window.countries;
            var idElementUnique = event.currentTarget.id.replace("country", "");
            var selectedCountryProperties = countries.find(function (country) { return country["printable_name"] == event.currentTarget.value; });
            document.getElementById("country_code" + idElementUnique).value =
                selectedCountryProperties["phone_code"];
            var countyIso = selectedCountryProperties["iso"];
            listStates(idElementUnique, countyIso);
        }
        function listStates(elementId, iso) {
            return __awaiter(this, void 0, void 0, function () {
                var stateSelectElement, requestBody, endpoint, options, request, response, states, option;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            stateSelectElement = document.getElementById("state" + elementId);
                            stateSelectElement.setAttribute("data-country-iso", iso);
                            requestBody = new FormData();
                            requestBody.append("country_iso", iso);
                            requestBody.append("_token", window.csrf_token);
                            endpoint = "/get-states";
                            options = {
                                method: "POST",
                                body: requestBody,
                            };
                            request = new Request(endpoint, options);
                            return [4 /*yield*/, fetch(request)];
                        case 1:
                            response = _a.sent();
                            return [4 /*yield*/, response.json()];
                        case 2:
                            states = _a.sent();
                            stateSelectElement.innerHTML = "";
                            option = document.createElement("option");
                            option.value = "";
                            option.innerText = "Select state";
                            stateSelectElement.appendChild(option);
                            states.forEach(function (state) {
                                var option = document.createElement("option");
                                option.value = state["state"];
                                option.innerText = state["state"];
                                option.setAttribute("data-state-iso", state["state_code"]);
                                stateSelectElement.appendChild(option);
                            });
                            return [2 /*return*/];
                    }
                });
            });
        }
        /**
         * @param {Event} event
         */
        function listCities(event) {
            return __awaiter(this, void 0, void 0, function () {
                var element, elementId, citySelector, selectedState, stateIso, countryIso, requestBody, endpoint, options, request, response, cities, option;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            element = event.target;
                            elementId = element.id.replace("state", "");
                            citySelector = document.getElementById("city" + elementId);
                            selectedState = element.querySelector("option:checked");
                            stateIso = selectedState.getAttribute("data-state-iso");
                            countryIso = element.getAttribute("data-country-iso");
                            requestBody = new FormData();
                            requestBody.append("state_code", stateIso);
                            requestBody.append("country_iso", countryIso);
                            requestBody.append("_token", window.csrf_token);
                            endpoint = "/get-cities";
                            options = {
                                method: "POST",
                                body: requestBody,
                            };
                            request = new Request(endpoint, options);
                            return [4 /*yield*/, fetch(request)];
                        case 1:
                            response = _a.sent();
                            return [4 /*yield*/, response.json()];
                        case 2:
                            cities = _a.sent();
                            citySelector.innerHTML = "";
                            option = document.createElement("option");
                            option.value = "";
                            option.innerText = "Select city";
                            citySelector.appendChild(option);
                            cities.forEach(function (city) {
                                var option = document.createElement("option");
                                option.value = city["city"];
                                option.innerText = city["city"];
                                citySelector.appendChild(option);
                            });
                            return [2 /*return*/];
                    }
                });
            });
        }
        /**
         * @param {Event} event
         */
        function workInstitutionChange(event) {
            var element_value = $(event.currentTarget).val();
            if (element_value) {
                if (element_value == "other_wa_institution_option") {
                    $(event.currentTarget)
                        .closest(".row")
                        .find(".other_wa_institution_div")
                        .show();
                }
                else {
                    $(event.currentTarget)
                        .closest(".row")
                        .find(".other_wa_institution_div")
                        .hide();
                }
            }
        }
        var __returned__ = { props: props, uniqueId: uniqueId, countries: countries, institutions: institutions, removeElement: removeElement, countryInputChange: countryInputChange, listStates: listStates, listCities: listCities, workInstitutionChange: workInstitutionChange, computed: reactivity_1.computed, jquery: jquery_1["default"] };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
